export default __webpack_public_path__ + "static/media/CTP_Light_ZH.712767d1.svg";